module.exports = __webpack_public_path__ + "img/area-chart-stepped-dark-01.1c726864.jpg";